import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import api from "../../../config/URL";
import profileImg from "../../../assets/images/profile.png";
import EditParentDetailModel from "./EditParentDetailModel";
import AddParentDetailModel from "./AddParentDetailModel";
import { GoDotFill } from "react-icons/go";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from "react-toastify";

const EditParentGuardian = forwardRef(
  ({ formData, setLoadIndicators, setFormData, handleNext }, ref) => {
    const [data, setData] = useState({});
    const [primaryContact, setPrimaryContact] = useState(false);
    const userName = localStorage.getItem("userName");

    const getData = async () => {
      setLoadIndicators(true);
      try {
        const response = await api.get(`/getAllStudentById/${formData.id}`);
        setData(response.data);
        setPrimaryContact(response.data.studentParentsDetails.length === 0);
      } catch (error) {
        toast.error("Error fetching data: " + (error.response?.data?.message || error.message));
      } finally {
        setLoadIndicators(false);
      }
    };

    useEffect(() => {
      getData();
    }, [formData.id]);

    const handleDeleteRow = async (id) => {
      try {
        const response = await api.delete(`/deleteStudentParentsDetails/${id}`);
        if (response.status === 200 || response.status === 201) {
          toast.success("Parent information deleted successfully");
          getData();
        }
      } catch (error) {
        toast.error("Error deleting parent information: " + (error.response?.data?.message || error.message));
      }
    };

    useImperativeHandle(ref, () => ({
      editParentGuardian: handleNext,
    }));

    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, []);

    return (
      <div className="container-fluid p-2">
        <h5 className="headColor mb-3">Parents / Guardian Details</h5>
        <table className="table table-border-solid">
          <thead className="table-light bg-warning">
            <tr>
              <th scope="col" className="fw-medium">S.No</th>
              <th scope="col" className="fw-medium">Parent Names</th>
              <th scope="col" className="fw-medium">Date Of Birth</th>
              <th scope="col" className="fw-medium">Relation</th>
              <th scope="col" className="fw-medium">Email</th>
              <th scope="col" className="fw-medium">Mobile No</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.studentParentsDetails && data.studentParentsDetails.length > 0 ? (
              data.studentParentsDetails.map((parent, index) => (
                <tr key={parent.id}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      {parent.profileImage ? (
                        <img
                          src={parent.profileImage || profileImg}
                          className="rounded-5 me-2"
                          style={{ width: "40px", height: "40px", objectFit: "cover" }}
                          alt="Parent Profile"
                          onError={(e) => (e.target.src = "/path/to/fallback-image.jpg")} // Fallback image
                        />
                      ) : (
                        <div
                          className="me-2"
                          style={{
                            width: "30px",
                            height: "40px",
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          No Image
                        </div>
                      )}
                      {parent.parentName}
                      {parent.primaryContact && <GoDotFill className="text-primary ms-2" />}
                    </div>
                  </td>
                  <td>{parent.parentDateOfBirth?.substring(0, 10) || "-"}</td>
                  <td>{parent.relation || "-"}</td>
                  <td>{parent.email || "-"}</td>
                  <td>{parent.mobileNumber || "-"}</td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center">
                      {/* {parent.primaryContact ? (
                        <button className="btn border-white" type="button" disabled>
                          <CiEdit className="text-secondary" />
                        </button>
                      ) : (
                        <EditParentDetailModel id={parent.id} getData={getData} />
                      )} */}
                      <EditParentDetailModel id={parent.id} getData={getData} />
                      {!parent.primaryContact && (
                        <button
                          className="btn"
                          type="button"
                          onClick={() => handleDeleteRow(parent.id)}
                        >
                          <MdDeleteOutline />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="row">
          <div className="col-md-2 col-12 text-start">
            <AddParentDetailModel primaryContact={primaryContact} onSuccess={getData} />
          </div>
        </div>
      </div>
    );
  }
);

export default EditParentGuardian;